export function RobotIcon(props: any) {
    return (
        <svg className="MicrosoftChat-icon" xmlns="http://www.w3.org/2000/svg" width="36" height="37" viewBox="0 0 36 37" fill="none">
            <path
                d="M18.3863 5.30105C28.2632 5.30105 33.158 9.73688 33.158 18.5198C33.158 27.3028 28.2632 31.8274 18.4738 31.8274C17.515 31.8274 16.6032 31.7848 15.7383 31.6998C14.6102 31.5889 10.9158 34.451 9.94745 34.1958C8.79417 33.8919 10.4004 30.4405 9.47376 29.9325C5.68428 27.8548 3.78955 24.0731 3.78955 18.6086C3.78955 9.8256 8.68427 5.30105 18.3863 5.30105Z"
                fill="white"
            />
            <path
                d="M14.0555 14.2567C15.0026 14.2567 15.4761 14.7302 15.4761 15.6773V17.098C15.4761 18.0451 15.0026 18.5186 14.0555 18.5186C13.1084 18.5186 12.6348 18.0451 12.6348 17.098V15.6773C12.6348 14.7302 13.1084 14.2567 14.0555 14.2567Z"
                fill="black"
            />
            <path
                d="M22.5794 14.2567C23.5265 14.2567 24.0001 14.7302 24.0001 15.6773V17.098C24.0001 18.0451 23.5265 18.5186 22.5794 18.5186C21.6323 18.5186 21.1588 18.0451 21.1588 17.098V15.6773C21.1588 14.7302 21.6323 14.2567 22.5794 14.2567Z"
                fill="black"
            />
            <path
                d="M22.17 21.5616C22.2847 21.4814 22.4141 21.4246 22.5508 21.3944C22.6876 21.3642 22.8289 21.3612 22.9667 21.3856C23.1046 21.41 23.2363 21.4613 23.3543 21.5366C23.4723 21.6119 23.5744 21.7097 23.6546 21.8245C23.7348 21.9392 23.7916 22.0686 23.8218 22.2053C23.8521 22.342 23.855 22.4833 23.8306 22.6212C23.8062 22.759 23.7549 22.8907 23.6796 23.0087C23.6043 23.1268 23.5065 23.2288 23.3918 23.309C21.9043 24.3489 20.2067 24.8717 18.3314 24.8717C16.4547 24.8717 14.7571 24.3489 13.2696 23.309C13.1549 23.2288 13.0571 23.1268 12.9818 23.0087C12.9065 22.8907 12.8552 22.759 12.8308 22.6212C12.8064 22.4833 12.8093 22.342 12.8396 22.2053C12.8698 22.0686 12.9266 21.9392 13.0068 21.8245C13.087 21.7097 13.1891 21.6119 13.3071 21.5366C13.4251 21.4613 13.5568 21.41 13.6947 21.3856C13.8325 21.3612 13.9738 21.3642 14.1105 21.3944C14.2472 21.4246 14.3767 21.4814 14.4914 21.5616C15.6165 22.3501 16.8866 22.7408 18.3314 22.7408C19.7748 22.7408 21.0448 22.3501 22.17 21.5616Z"
                fill="black"
            />
        </svg>
    );
}

export function OuterRingIcon(props: any) {
    return (
        <svg className="MicrosoftChat-icon" xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
            <g filter="url(#filter0_i_13_1031)">
                <g clipPath="url(#clip0_13_1031)">
                    <rect y="0.564209" width="48" height="48" rx="24" fill="url(#paint0_linear_13_1031)" fillOpacity="0.88" />
                    <g filter="url(#filter1_f_13_1031)">
                        <path
                            d="M30.5968 25.5642C40.4737 25.5642 45.3684 30 45.3684 38.783C45.3684 47.566 40.4737 52.0905 30.6842 52.0905C20.8947 52.0905 16 47.6547 16 38.8717C16 30.0888 20.8947 25.5642 30.5968 25.5642Z"
                            fill="url(#paint1_linear_13_1031)"
                        />
                    </g>
                </g>
            </g>
            <defs>
                <filter id="filter0_i_13_1031" x="0" y="0.564209" width="48" height="48" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="8" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_13_1031" />
                </filter>
                <filter
                    id="filter1_f_13_1031"
                    x="-0.4"
                    y="9.16421"
                    width="62.1687"
                    height="59.3263"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feGaussianBlur stdDeviation="8.2" result="effect1_foregroundBlur_13_1031" />
                </filter>
                <linearGradient id="paint0_linear_13_1031" x1="35" y1="44.5642" x2="24" y2="0.56421" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#8000FF" />
                    <stop offset="1" stopColor="#006AFF" />
                </linearGradient>
                <linearGradient id="paint1_linear_13_1031" x1="33.5" y1="23.0642" x2="37.5" y2="57.0642" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#9500FF" />
                    <stop offset="1" stopColor="#FFB700" />
                </linearGradient>
                <clipPath id="clip0_13_1031">
                    <rect y="0.564209" width="48" height="48" rx="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
